/* SelmaCilek ürün kartları — her sayfada sc-announcement ile yüklenir (defer).
   1) Dekupe: karar sunucuda. snippets/sc-cut-list.liquid'deki dosyalar HTML'de .sc-cut (fotoğraf) + .sc-cutbox (kutu) ile
      gelir; JS ile çizilen kartlar için aynı liste window.scCutList'te durur (ürün sayfası). Bu fotoğraflar yeniden
      sınıflandırılmaz, .sc-cut asla kaldırılmaz; aynı alan adındaysa yalnızca zemin tonu ölçülür (--sc-cut-k, --sc-cut-rgb).
      Yedek (listede olmayan yeni fotoğraflar): 24×36'lık küçük kopyanın 2 px'lik kenar çerçevesi ölçülür; kanallar ≥ 238,
      kenarın ≥ %60'ı ve ≥ 3 köşe beyaz, düşük sapma → dekupe (.sc-cut / .sc-cutbox), değilse .sc-nocut (olduğu gibi kalır).
      Görünüm kuralları: sc-base.css "Dekupe" bloğu. Kapsam: kartın ilk fotoğrafı, masaüstünde üzerine gelince açılan ikinci
      fotoğraf, telefondaki kaydırma şeridi (product-grid-item), ana sayfa "New in" şeridi (.sclb-card__im), ürün sayfası
      kartları (.scp-cimg). Başka alan adındaki fotoğraf (tema düzenleyici, önizleme) tuvalde okunamaz: 48 px'lik kopyası
      CORS ile indirilip (Shopify CDN: Access-Control-Allow-Origin *) aynı ölçüm yapılır (remote()). Sonuçlar tarayıcıda saklanır.
   2) Telefonda kart fotoğraf şeridinin ince konum çizgisi + sıradaki fotoğrafın önden yüklenmesi.
   Sonradan eklenen kartlar (filtre, sayfalama, sonsuz kaydırma, hızlı bakış, önerilenler) MutationObserver ile yakalanır. */
(function () {
  'use strict';
  if (window.__scGrid) return;
  window.__scGrid = true;

  var IMG_SEL = '.grid-product .grid__image-ratio img, .grid-product__secondary-image img, .sclb-card__im img, .scp-cimg img';
  var BOX_SEL = '.grid__image-ratio, .grid-product__secondary-image, .sclb-card__im, .scp-cimg';
  var W = 24, H = 36, F = 2, MIN = 238;
  var CK = 'scCut2';
  var cache = {};
  try {
    window.localStorage.removeItem('scCut1'); // eski önbellek
    cache = JSON.parse(window.localStorage.getItem(CK) || '{}') || {};
  } catch (e) { cache = {}; }

  var saveT = 0;
  function save() {
    clearTimeout(saveT);
    saveT = setTimeout(function () {
      try {
        var k = Object.keys(cache);
        if (k.length > 800) k.slice(0, k.length - 600).forEach(function (x) { delete cache[x]; });
        window.localStorage.setItem(CK, JSON.stringify(cache));
      } catch (e) {}
    }, 1000);
  }

  // Aynı dosya = aynı sonuç (genişlik parametresi önemsiz). f: dosya adı (sunucu listesiyle karşılaştırılır).
  function keyOf(img) {
    var s = img.currentSrc || img.src;
    if (!s) return null;
    var u;
    try { u = new URL(s, location.href); } catch (e) { return null; }
    var v = u.searchParams.get('v'), f = u.pathname.split('/').pop();
    return { k: f + (v ? '@' + v : ''), f: f, same: u.origin === (window.origin || location.origin) };
  }
  function listed(f) {
    var l = window.scCutList;
    return typeof l === 'string' && l.indexOf('|' + f + '|') > -1;
  }

  function boxesOf(img) {
    var out = [];
    var slide = img.closest('.sc-swipe__slide');
    if (slide) out.push(slide);
    if (!slide || !slide.previousElementSibling) {
      var box = img.closest(BOX_SEL);
      if (box) out.push(box);
    }
    return out;
  }

  function apply(img, r) {
    var srv = img.getAttribute('data-sc-cut') === 's';
    var cut = srv || (r && r[0] === 1); // sunucu kararı değişmez
    img.classList.toggle('sc-cut', cut);
    img.classList.toggle('sc-nocut', !cut);
    if (cut && r && r[1] > 1) img.style.setProperty('--sc-cut-k', r[1]);
    boxesOf(img).forEach(function (b) {
      b.classList.toggle('sc-cutbox', cut);
      b.classList.toggle('sc-nocutbox', !cut);
      if (cut && r && r[2]) b.style.setProperty('--sc-cut-rgb', r[2]);
    });
    if (!srv) img.setAttribute('data-sc-cut', cut ? '1' : '0');
  }

  var cv, cx;
  function measure(img) {
    if (!cv) {
      cv = document.createElement('canvas');
      cv.width = W; cv.height = H;
      cx = cv.getContext('2d', { willReadFrequently: true });
    }
    cx.fillStyle = '#fff';           // saydam PNG: saydam kenar = beyaz sayılır
    cx.fillRect(0, 0, W, H);
    cx.drawImage(img, 0, 0, W, H);
    var d = cx.getImageData(0, 0, W, H).data; // başka alan adıysa hata verir → atlanır
    var n = 0, nw = 0, r = 0, g = 0, b = 0, sum = 0, sq = 0, x, y, i, l, white;
    var corner = [0, 0, 0, 0];
    for (y = 0; y < H; y++) {
      for (x = 0; x < W; x++) {
        if (x >= F && x < W - F && y >= F && y < H - F) continue;
        i = (y * W + x) * 4;
        n++;
        white = d[i] >= MIN && d[i + 1] >= MIN && d[i + 2] >= MIN;
        if (!white) continue;
        nw++;
        r += d[i]; g += d[i + 1]; b += d[i + 2];
        l = (d[i] + d[i + 1] + d[i + 2]) / 3;
        sum += l; sq += l * l;
        if (x < F && y < F) corner[0]++;
        else if (x >= W - F && y < F) corner[1]++;
        else if (x < F && y >= H - F) corner[2]++;
        else if (x >= W - F && y >= H - F) corner[3]++;
      }
    }
    // Kenarın çoğu (ürün kenara değebilir) ve köşelerin en az üçü beyaz olmalı
    var full = corner.filter(function (c) { return c === F * F; }).length;
    if (!nw || nw / n < 0.6 || full < 3) return [0];
    var m = sum / nw, sd = Math.sqrt(Math.max(0, sq / nw - m * m));
    r /= nw; g /= nw; b /= nw;
    var lo = Math.min(r, g, b);
    if (sd > 5 || Math.max(r, g, b) - lo > 12) return [0]; // dalgalı ya da renkli zemin: dekupe değil
    var k = lo >= 254.5 ? 1 : Math.min(1.1, 255 / Math.max(200, lo - 1.5));
    return [1, Math.round(k * 10000) / 10000, Math.round(r) + ' ' + Math.round(g) + ' ' + Math.round(b)];
  }

  var queue = [], pumping = false;
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 50); };
  function pump() {
    if (pumping || !queue.length) return;
    pumping = true;
    idle(function () {
      pumping = false;
      var t0 = Date.now();
      while (queue.length && Date.now() - t0 < 10) run(queue.shift());
      if (queue.length) pump();
    }, { timeout: 300 });
  }
  // 'p': yedek ölçüm bekliyor, 's': sunucu dekupesi (yalnızca zemin tonu ölçülür)
  function run(img) {
    var st = img.getAttribute('data-sc-cut');
    if (!img.isConnected || (st !== 'p' && st !== 's')) return;
    var k = keyOf(img), r;
    if (!k || !k.same) { if (st === 'p') img.setAttribute('data-sc-cut', 'x'); return; }
    try { r = measure(img); } catch (e) { if (st === 'p') img.setAttribute('data-sc-cut', 'x'); return; }
    if (st === 's' && r[0] !== 1) r = [1]; // zemin ölçülemedi (ör. ürün kenara değiyor): ton düzeltmesi yok
    cache[k.k] = r; save();
    apply(img, r);
  }
  function wait(img) {
    if (img.complete && img.naturalWidth) { queue.push(img); pump(); }
    else img.addEventListener('load', onLoad);
  }
  function onLoad(e) {
    var img = e.target;
    img.removeEventListener('load', onLoad);
    queue.push(img); pump();
  }
  // başka alan adı: 48 px kopya CORS ile, aynı anda en fazla 4 istek
  var CORS_OK = !!(window.fetch && window.createImageBitmap && window.URL), rq = [], ract = 0;
  function remote(img, k) {
    if (!CORS_OK) { if (img.getAttribute('data-sc-cut') === 'p') img.setAttribute('data-sc-cut', 'x'); return; }
    rq.push([img, k]); rpump();
  }
  function rpump() { while (ract < 4 && rq.length) rone(rq.shift()); }
  function rone(it) {
    var img = it[0], k = it[1], st = img.getAttribute('data-sc-cut'), u;
    if (!img.isConnected || (st !== 'p' && st !== 's')) return;
    try { u = new URL(img.currentSrc || img.getAttribute('src'), location.href); u.searchParams.set('width', '48'); }
    catch (e) { if (st === 'p') img.setAttribute('data-sc-cut', 'x'); return; }
    ract++;
    fetch(u.href, { mode: 'cors', credentials: 'omit' })
      .then(function (res) { if (!res.ok) throw new Error('http'); return res.blob(); })
      .then(function (b) { return createImageBitmap(b); })
      .then(function (bm) {
        var r = measure(bm);
        if (bm.close) bm.close();
        if (st === 's' && r[0] !== 1) r = [1];
        cache[k.k] = r; save();
        apply(img, r);
      })
      .catch(function () { if (img.getAttribute('data-sc-cut') === 'p') img.setAttribute('data-sc-cut', 'x'); })
      .then(function () { ract--; rpump(); });
  }
  function consider(img) {
    if (img.hasAttribute('data-sc-cut')) return;
    if (!img.getAttribute('src') && img.hasAttribute('data-sc-src')) return; // henüz yüklenmemiş şerit fotoğrafı
    var k = keyOf(img), c = k && cache[k.k];
    // sunucu listesi: HTML'de .sc-cut ya da window.scCutList
    if (img.classList.contains('sc-cut') || (k && listed(k.f))) {
      img.setAttribute('data-sc-cut', 's');
      apply(img, c && c[0] === 1 ? c : null);
      if (k && !c) { if (k.same) wait(img); else remote(img, k); }
      return;
    }
    if (!k) { img.setAttribute('data-sc-cut', 'x'); return; }
    if (c) { apply(img, c); return; }
    if (!k.same) { img.setAttribute('data-sc-cut', 'p'); remote(img, k); return; }
    img.setAttribute('data-sc-cut', 'p');
    wait(img);
  }

  // --- telefon kaydırma şeridi
  function initSwipe(box) {
    if (box.__scSwipe) return;
    var tr = box.querySelector('.sc-swipe__track');
    var dots = box.querySelectorAll('.sc-swipe__dots i');
    if (!tr) return;
    box.__scSwipe = true;
    var cur = 0, raf = 0, hydrated = false;
    function warm(i) {
      var s = tr.children[i], im = s && s.querySelector('img[loading="lazy"]');
      if (im) im.loading = 'eager';
    }
    // 3.–5. fotoğraflar sayfa açılışında indirilmez; kart kaydırılmaya başlanınca yüklenir
    function hydrate() {
      if (hydrated) return;
      hydrated = true;
      var list = tr.querySelectorAll('img[data-sc-src]');
      for (var i = 0; i < list.length; i++) {
        var im = list[i];
        im.setAttribute('srcset', im.getAttribute('data-sc-srcset'));
        im.setAttribute('src', im.getAttribute('data-sc-src'));
        im.removeAttribute('data-sc-srcset');
        im.removeAttribute('data-sc-src');
        consider(im);
      }
    }
    function update() {
      raf = 0;
      var w = tr.clientWidth || 1, i = Math.round(Math.abs(tr.scrollLeft) / w);
      if (i !== cur && dots[i]) {
        if (dots[cur]) dots[cur].classList.remove('is-on');
        dots[i].classList.add('is-on');
        cur = i;
      }
      warm(i + 1);
    }
    tr.addEventListener('scroll', function () { hydrate(); if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    tr.addEventListener('touchstart', function () { warm(cur + 1); hydrate(); }, { passive: true });
    tr.addEventListener('pointerdown', hydrate, { passive: true });
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(IMG_SEL)) consider(root);
    var imgs = root.querySelectorAll ? root.querySelectorAll(IMG_SEL) : [];
    for (var i = 0; i < imgs.length; i++) consider(imgs[i]);
    if (root.classList && root.classList.contains('sc-swipe')) initSwipe(root);
    var sw = root.querySelectorAll ? root.querySelectorAll('.sc-swipe') : [];
    for (var j = 0; j < sw.length; j++) initSwipe(sw[j]);
  }

  var pending = [], sched = 0;
  function flush() {
    sched = 0;
    var list = pending; pending = [];
    for (var i = 0; i < list.length; i++) if (list[i].isConnected) scan(list[i]);
  }
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var add = muts[i].addedNodes;
      for (var j = 0; j < add.length; j++) if (add[j].nodeType === 1) pending.push(add[j]);
    }
    if (pending.length && !sched) sched = requestAnimationFrame(flush);
  });

  function start() {
    scan(document.body);
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
